import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[cleanInput]'
})
export class CleanInputDirective {

  constructor(private ngControl: NgControl, private el: ElementRef<HTMLInputElement>) {}

  //  Intercetta il paste globale
  @HostListener('document:paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const target = event.target as HTMLElement;

    // gestisci solo se l'input incollato è quello associato
    if (target !== this.el.nativeElement) return;

    event.preventDefault();
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    let pastedText = clipboardData.getData('text');

    pastedText = this.cleanText(pastedText);

    const input = this.el.nativeElement;
    const start = input.selectionStart || 0;
    const end = input.selectionEnd || 0;
    const newValue = input.value.slice(0, start) + pastedText + input.value.slice(end);

    input.value = newValue;
    if (this.ngControl?.control) {
      this.ngControl.control.setValue(newValue);
    }
  }

  //  Pulizia continua anche su input normale
  // @HostListener('input', ['$event'])
  // onInput(event: Event) {
  //   debugger
  //   const target = event.target as HTMLElement;
  //   // gestisci solo se l'input incollato è quello associato
  //   if (target !== this.el.nativeElement) return;
  //   event.preventDefault();
  //   const input = this.el.nativeElement;
  //   const cleaned = this.cleanText(input.value);
  //   if (cleaned !== input.value) {
  //     input.value = cleaned;
  //     if (this.ngControl?.control) {
  //       this.ngControl.control.setValue(cleaned, { emitEvent: false });
  //     }
  //   }
  // }

  private cleanText(value: string): string {
    return value
        //  Rimuove spazi invisibili e non-breaking spaces
        .replace(/[\u200B-\u200D\uFEFF\u00A0]/g, '')
        //  Sostituisce apostrofi tipografici con quello ASCII
        .replace(/[\u2018\u2019\u02BC]/g, "'")
        //  Normalizza caratteri compatibili Unicode
        .normalize('NFKC')
        //  Rimuove spazi iniziali e finali
        .trim();
  }

}
